var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-control dsf_teas_class_album_list mobile" },
    [
      _c(
        "div",
        { staticClass: "class_album_list" },
        [
          _c("div", { staticClass: "album_item" }, [
            _c(
              "div",
              {
                staticClass: "album_img",
                on: {
                  click: function ($event) {
                    return _vm.toAlbumIndex()
                  },
                },
              },
              [
                _c("i", { staticClass: "iconfont icon-charutupian" }),
                _c("span", [_vm._v("新建相册")]),
              ]
            ),
            _c("div", { staticClass: "album_info_zw" }),
          ]),
          _vm._l(_vm.albumList, function (item, index) {
            return _c("div", { key: index, staticClass: "album_item" }, [
              _c(
                "div",
                {
                  staticClass: "album_img_box",
                  on: {
                    click: function ($event) {
                      return _vm.toDetails(item)
                    },
                  },
                },
                [
                  _c("van-image", {
                    attrs: {
                      src: _vm._f("imgFormat")(item.coverPhoto),
                      width: "100%",
                      height: "100%",
                      fit: "cover",
                      radius: "4",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "error",
                          fn: function () {
                            return [
                              _c("img", {
                                staticClass: "err_img",
                                attrs: {
                                  src: require("../../assets/styles/themes/img/img-nopicture.png"),
                                  alt: "",
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "album_info" }, [
                _c("div", { staticClass: "album_title" }, [
                  _c("div", [_vm._v(_vm._s(item.albumName))]),
                  _c(
                    "span",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.toAlbumIndex(item)
                        },
                      },
                    },
                    [_vm._v("编辑")]
                  ),
                ]),
                _c("div", { staticClass: "album_info_num" }, [
                  _c("div", [_vm._v(_vm._s(item.photoNum || 0) + "张")]),
                  _c("span", [_vm._v(_vm._s(item.dsCreateUserName) + "创建")]),
                ]),
              ]),
            ])
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }